import { render, staticRenderFns } from "./GridVideos.vue?vue&type=template&id=5b9ec238&"
import script from "./GridVideos.vue?vue&type=script&lang=js&"
export * from "./GridVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports